import { useState } from 'react';
import { useStore } from '../store';
import type { HeaderRow as HeaderRowType } from '@xsscool/shared';
import { HeaderValuePicker, pickerKindForHeaderName } from './pickers';

interface Props {
  row: HeaderRowType;
}

export function HeaderRow({ row }: Props) {
  const updateHeader = useStore((s) => s.updateHeader);
  const removeHeader = useStore((s) => s.removeHeader);
  const pickerKind = pickerKindForHeaderName(row.name);
  const [pickerOpen, setPickerOpen] = useState(false);

  return (
    <div className="header-row-wrap">
      <div className="headers-row">
        <input
          list="header-name-suggestions"
          placeholder="Header name"
          value={row.name}
          onChange={(e) => updateHeader(row.id, { name: e.target.value })}
        />
        <input
          placeholder="Value"
          value={row.value}
          onChange={(e) => updateHeader(row.id, { value: e.target.value })}
        />
        {pickerKind ? (
          <button
            className="picker-toggle"
            onClick={() => setPickerOpen((v) => !v)}
            title={pickerOpen ? 'Hide picker' : 'Show picker'}
            type="button"
          >
            {pickerOpen ? '▾' : '▸'}
          </button>
        ) : (
          <span />
        )}
        <button
          className="remove"
          onClick={() => removeHeader(row.id)}
          aria-label="Remove header"
          title="Remove"
          type="button"
        >
          ×
        </button>
      </div>
      {pickerKind && pickerOpen && (
        <div className="picker-shell">
          <HeaderValuePicker
            kind={pickerKind}
            value={row.value}
            onChange={(next) => updateHeader(row.id, { value: next })}
          />
        </div>
      )}
    </div>
  );
}
